import Base from "@/controllers/base";
export default class Operation extends Base {
  constructor(elem) {
    super(elem);
  }
  previewContent() {
    const target = document.querySelector("#preview-content");
    if (!target) return;
    target.innerHTML = this.value
      .replace(/\n/g, "<br>")
      .replace(/\s/g, "&nbsp;");
    target.highlight("yellow", 1000);
  }

  async submitThenRequest(event) {
    try {
      const link = event.target.closest("a");
      const url = link.dataset.url;
      const orderForm = link.closest("form");
      link.setAttribute("disabled", true);
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": this.authenticityToken,
        },
        body: new FormData(orderForm),
      });
      Turbo.renderStreamMessage(await response.text());
      link.removeAttribute("disabled");
    } catch (ex) {
      console.log(ex);
    }
  }
}
